<template>
  <div class="edit-users-groups-right rule-set conmon-top">
    <el-row class="users-groups-content">
      <el-col :span="20" class="add-product-info-search-title" style="padding: 20px 0 0 20px;text-align: left">
        <span class="product-info-span">当前角色: <span style="color:#4882ff">{{form.title}}</span></span>
      </el-col>
      <!--<el-col :span="4" class="text-align-right">
        <el-button type="primary" class="btn-link-large add-btn btn-right" style="border-radius: 17px;margin-top: 10px" @click="openAddDialog">
          添加权限
        </el-button>
      </el-col>-->
    </el-row>
    <el-form ref="form" :model="form" label-width="40px" class="edit-users-groups-form form-submit-page" style="width: 97%">
      <el-form-item>
        <div class=" bor-ra-5 bg-wh">
          <div :key="index" v-for="(item, index) in nodes" style="text-align: left;">
            <div :key="i" v-for="(childItem, i) in item.child" class="">
              <div class="p-l-20  bor-gray edit-users-groups-nodes" style="padding-left: 20px">
                <el-checkbox v-model="childItem.check" @change="selectModuleRule(childItem, item, childItem.child)">{{childItem.else}}</el-checkbox>
              </div>
              <div v-if="childItem.child" class="p-l-40 bg-gra bor-gray edit-users-groups-part" style="padding-left: 20px;background: #fff">
                <el-checkbox :key="j" v-for="(grandChildItem, j) in childItem.child" v-model="grandChildItem.check" @change="selectActionRule(grandChildItem, childItem, item)">{{grandChildItem.else}}</el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="edit-users-groups-commit-content" style="margin: 0 auto 10px">
        <el-button class="second-page-btn" type="primary" @click="edit('form')" :loading="isLoading" style="margin: 0 auto;display: block;float: none">保存</el-button>
      </el-form-item>
    </el-form>

    <!--添加角色弹窗-->
    <el-dialog class="cellDialog base-dialog" title="添加权限" :visible.sync="adddialog" width="520px">
      <el-form ref="addForm" :model="addForm" :rules="rules">
        <el-form-item label="名称:" :label-width="addLabelWidth" prop="title">
          <el-input class="stockInput" type="text" v-model="addForm.title" auto-complete="off" placeholder="输入权限名称"></el-input>
        </el-form-item>
        <el-form-item label="定义:" :label-width="addLabelWidth" prop="name">
          <el-input class="stockInput" type="text" v-model="addForm.name" auto-complete="off" placeholder="输入权限定义"></el-input>
        </el-form-item>
        <el-form-item label="所属父级:" :label-width="addLabelWidth" prop="pid">
          <el-select v-model="addForm.pid" placeholder="请选择">
            <el-option v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { getYxRuleList, getYxRoleDetail, editYxRole, getRulesByPid, addYxRule } from '@/api/yunxiao.js'
export default {
  data() {
    return {
      isLoading: false,
      type: 'tree',
      form: {
        id: null,
        title: '',
        pid: '',
        remark: '',
        rules: [],
        status: null
      },
      options: [{ pid: '', title: '无' }],
      nodes: [],
      selectedNodes: [],
      adddialog: false,
      addLabelWidth: '80px',
      addForm: {
        title: '',
        name: '',
        pid: '',
        level: '',
      },
      rules: {
        title: [
          { required: true, message: '请输入权限名称', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入权限定义', trigger: 'blur' }
        ],
        pid: [
          { required: true, message: '请选择所属父级', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    // 保存编辑
    edit(form) {
      let id = this.$route.query.id
      this.form.rules = this.selectedNodes.toString()
      this.$refs[form].validate((valid) => {
        if (valid) {
          editYxRole(this.form.title, this.form.remark, this.form.rules, id).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', '编辑成功')
              router.push('/home/yxgroup')
            }
          })
          this.isLoading = !this.isLoading
        }
      })
    },
    // 选择大的checkbox
    selectModuleRule(item, faItem, children) {
      if (!faItem.check) {
        faItem.check = true
        this.selectedNodes.push(faItem.id)
      }
      if (item.check) {
        this.selectedNodes.push(item.id)
        _(children).forEach((res) => {
          res.check = true
          this.selectedNodes.push(res.id)
        })
      } else {
        let index = _(this.selectedNodes).indexOf(item.id)
        this.selectedNodes.splice(index, 1)
        _(children).forEach((res1) => {
          let temp = _(this.selectedNodes).indexOf(res1.id)
          if (temp >= 0) {
            res1.check = false
            this.selectedNodes.splice(temp, 1)
          }
        })
      }
    },
    // 选择小的checkbox
    selectActionRule(item, faItem, grandFaItem) {
      if (!faItem.check) {
        faItem.check = true
        this.selectedNodes.push(faItem.id)
      }
      if (!grandFaItem.check) {
        grandFaItem.check = true
        this.selectedNodes.push(grandFaItem.id)
      }
      this.selectRule(item)
    },
    selectRule(item) {
      if (item.check) {
        this.selectedNodes.push(item.id)
      } else {
        const index = _(this.selectedNodes).indexOf(item.id)
        this.selectedNodes.splice(index, 1)
      }
    },
    // 打开添加弹窗
    openAddDialog() {
      this.adddialog = true
      this.addForm.name = ''
      this.addForm.title = ''
      this.addForm.pid = ''
      this.addForm.level = ''
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAdd()
        } else {
          return false
        }
      })
    },
    // 确认添加角色
    confirmAdd() {
      var arr = this.addForm.pid.split(',')
      this.addForm.pid = arr[0]
      this.addForm.level = arr[1]+1
      addYxRule(this.addForm.title, this.addForm.name, this.addForm.level, this.addForm.pid).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '添加成功')
          this.adddialog = false
          this.load()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    getRulesByPid(){
      //获取顶级权限id
      this.options = []
      getRulesByPid(0).then((res) => {
        if (res.data.code === 0) {
          let rules = res.data.data.list
          if(rules.length>0){
            let pid = rules[0]['id']
            this.options.push({
              label: rules[0]['title'],
              value: pid + ',' + rules[0]['level']
            })
            //console.log(this.options)
            //获取二级权限列表
            getRulesByPid(pid).then((res) => {
              if (res.data.code === 0) {
                let rules = res.data.data.list
                for (let item of rules) {
                  this.options.push({
                    label: item.title,
                    value: item.id + ',' + item.level
                  })
                }
              }
            })
          }
        }
      })
    },
    load() {
      let id = this.$route.query.id
      // 获取权限集合
      let getRule = getYxRuleList(this.type)
      // 获取角色详情
      let getRoleDetails = getYxRoleDetail(id)
      // promise
      Promise.all([getRule, getRoleDetails]).then(res => {
        //权限列表
        if (res[0].data.code === 0) {
          this.nodes = res[0].data.data.list
          //console.log(this.nodes)
        }
        // 处理角色
        if (res[1].data.code === 0) {
          //console.log(res[1].data.data.title)
          this.form.title = res[1].data.data.title
          this.form.remark = res[1].data.data.remark
          this.form.pid = res[1].data.data.pid ? res[1].data.data.pid.toString() : ''
          this.form.status = res[1].data.data.status
          if (res[1].data.data.rules === null) {
            return
          }
          let array = res[1].data.data.rules.split(',')
          //console.log('array', array)
          _(array).forEach((ret) => {
            this.selectedNodes.push(parseInt(ret))
          })
          _(this.nodes).forEach((ret) => {
            if (_.includes(this.selectedNodes, ret.id)) {
              ret.check = true
            }
            _(ret.child).forEach((ret1) => {
              if (_(this.selectedNodes).includes(ret1.id)) {
                ret1.check = true
              }
              if(ret1.child !='undefined') {
                _(ret1.child).forEach((ret2) => {
                  if (_(this.selectedNodes).includes(ret2.id)) {
                    ret2.check = true
                  }
                })
              }
            })
          })
        }
      })
    }
  },
  created() {
    this.load()
    //this.getRulesByPid()
  }
}
</script>
<style type="text/css" scoped>
.edit-users-groups-right {
  float: left;
  background-color: #fff;
  border: 1px solid #dedede;
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 20px!important;
}
.users-groups-content {
  float: left;
  width: 100%;
  border-radius: 0px;
}
.edit-users-groups-form {
  float: left;
  /*margin-top: 20px;*/
}
.edit-users-groups-nodes {
  margin-top: 20px;
  background: #ebeff4;
  /*border-top: 1px solid #dedede;*/
}
.edit-users-groups-part {
  border-top-width: 0px !important;
}
.edit-users-groups-commit-content {
  margin-left: 37%;
  margin-top: 40px;
}
.edit-users-groups-back {
  background-color: #4882ff;
  color: #fff;
  float: right;
  margin-right: 20px;
  padding: 5px 20px 5px 20px;
  margin-top: 10px;
}
.el-checkbox{
  margin-right: 30px;
  margin-left: 0 !important;
}
.el-checkbox+.el-checkbox{
  margin-left: 0;
}
</style>
